export default __webpack_public_path__ + "static/media/edit.6376fccb.svg";